import { ElementRef } from '@angular/core';
import { DATA_EXPORT_FEATURE, GENERATE_PDF_REPORT_FEATURE, METRICS_FEATURE, STATIC_PDF_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { CSV_FORMAT, PDF_FORMAT } from 'NewAngular/constants/core.constants';
import { FLATTENED_HOLDINGS } from 'SecuritiesApp/ts/constants/holdings-table.constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { HoldingsTableDirective } from 'SecuritiesApp/ts/directives/holdings-table.directive';
import { downloadUrl } from 'NewAngular/utils/download';
import { getFormatter } from 'NewAngular/utils/number_formatter';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i8 from "../../../../../../../ycharts/static/ts/features/components/pagination/pagination-controls/pagination-controls.component";
import * as i9 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i10 from "SecuritiesApp/ts/features/flattened-holdings-table/flattened-holding-item.component";
const _c0 = () => [];
function FlattenedHoldingsTableComponent_table_16_tbody_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tbody", 33);
} if (rf & 2) {
    const holding_r3 = ctx.$implicit;
    const even_r4 = ctx.even;
    i0.ɵɵproperty("holding", holding_r3)("fillRowBackground", even_r4);
} }
function FlattenedHoldingsTableComponent_table_16_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table", 24)(1, "thead", 25)(2, "tr", 26)(3, "th", 27);
    i0.ɵɵlistener("click", function FlattenedHoldingsTableComponent_table_16_Template_th_click_3_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setTableSortProperties("ticker")); });
    i0.ɵɵelementStart(4, "span", 28);
    i0.ɵɵtext(5, "Symbol");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "th", 29);
    i0.ɵɵlistener("click", function FlattenedHoldingsTableComponent_table_16_Template_th_click_6_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setTableSortProperties("name")); });
    i0.ɵɵelementStart(7, "span", 28);
    i0.ɵɵtext(8, "Name");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "th", 30);
    i0.ɵɵlistener("click", function FlattenedHoldingsTableComponent_table_16_Template_th_click_9_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setTableSortProperties("current_weight")); });
    i0.ɵɵelementStart(10, "span", 28);
    i0.ɵɵtext(11, "%\u00A0Weight");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "th", 31);
    i0.ɵɵlistener("click", function FlattenedHoldingsTableComponent_table_16_Template_th_click_12_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setTableSortProperties("latest_quote")); });
    i0.ɵɵelementStart(13, "span", 28);
    i0.ɵɵtext(14, "Price");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "th", 31);
    i0.ɵɵlistener("click", function FlattenedHoldingsTableComponent_table_16_Template_th_click_15_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setTableSortProperties("change_percent")); });
    i0.ɵɵelementStart(16, "span", 28);
    i0.ɵɵtext(17, "%\u00A0Change");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(18, FlattenedHoldingsTableComponent_table_16_tbody_18_Template, 1, 2, "tbody", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortNgClass("ticker"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortNgClass("name"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortNgClass("current_weight"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortNgClass("latest_quote"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortNgClass("change_percent"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.formattedHoldings);
} }
function FlattenedHoldingsTableComponent_table_17_tr_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2, "--");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td")(4, "a", 36);
    i0.ɵɵtext(5, "Upgrade");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "td", 37);
    i0.ɵɵtext(7, "--");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td", 37);
    i0.ɵɵtext(9, "--");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 37);
    i0.ɵɵtext(11, "--");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("href", ctx_r1.featurePaymentUrl, i0.ɵɵsanitizeUrl);
} }
function FlattenedHoldingsTableComponent_table_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 34)(1, "tbody");
    i0.ɵɵtemplate(2, FlattenedHoldingsTableComponent_table_17_tr_2_Template, 12, 1, "tr", 35);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c0).constructor(5));
} }
function FlattenedHoldingsTableComponent_ycn_loading_symbol_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 38);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading Data...");
} }
/**
 *
 * FlattenedHoldingsTableComponent.
 *
 * Required Attributes:
 *      @ securityId : `security_id` for the given security
 *      @ featurePaymentUrl : url for upgrading if user does not have required feature
 */
export class FlattenedHoldingsTableComponent extends HoldingsTableDirective {
    constructor(featuresService, securitiesService, eltRef) {
        super(featuresService, securitiesService);
        this.featuresService = featuresService;
        this.securitiesService = securitiesService;
        this.eltRef = eltRef;
        this.securityInput = '';
        this.displaySecurityInput = null;
        this.exportDropdownConfig = {
            title: {
                label: 'Export',
                icon: 'icon-export',
            },
            list: [
                { type: 'option', label: 'Export Data', value: CSV_FORMAT, icon: 'icon-csv' },
                { type: 'option', label: 'Download PDF', value: PDF_FORMAT, icon: 'icon-download' },
            ],
        };
        this.securityId = eltRef.nativeElement.getAttribute('securityId');
        this.displaySecurityId = eltRef.nativeElement.getAttribute('displaySecurityId');
        this.featurePaymentUrl = eltRef.nativeElement.getAttribute('featurePaymentUrl');
        this.type = FLATTENED_HOLDINGS;
    }
    ngOnInit() {
        if (this.securityInput !== '') {
            this.securityId = this.securityInput;
        }
        if (this.displaySecurityInput !== null) {
            this.displaySecurityId = this.displaySecurityInput;
        }
        if (this.featuresService.userHasFeatures([METRICS_FEATURE])) {
            this.hasRequiredFeature = true;
            this.getHoldings();
        }
        else {
            this.hasRequiredFeature = false;
        }
        const hasDataExportFeature = this.featuresService.userHasFeatures([DATA_EXPORT_FEATURE]);
        const hasStaticPDFFeature = this.featuresService.userHasSomeFeatures([
            GENERATE_PDF_REPORT_FEATURE,
            STATIC_PDF_FEATURE,
        ]);
        this.exportDropdownConfig.list = this.exportDropdownConfig.list.map((item) => {
            if (item.value === CSV_FORMAT)
                return { ...item, disabled: !hasDataExportFeature };
            if (item.value === PDF_FORMAT)
                return { ...item, disabled: !hasStaticPDFFeature };
            return item;
        });
    }
    ngOnChanges() {
        if (this.securityInput !== '') {
            this.securityId = this.securityInput;
        }
        if (this.featuresService.userHasFeatures([METRICS_FEATURE])) {
            this.hasRequiredFeature = true;
            this.getHoldings();
        }
        else {
            this.hasRequiredFeature = false;
        }
    }
    /**
     * Set up the CSS and formatted values for each holding in `holdings`.
     *
     * @param holdings: Flattened holdings for the model portfolio.
     */
    formatHoldings(holdings) {
        const valFormatter = getFormatter('percent');
        const figureMoneyFormatter = getFormatter('figure_money');
        return holdings.map((holding) => {
            const formattedHolding = { ...holding };
            const changePercentVal = formattedHolding.change_percent;
            const currentWeight = formattedHolding.current_weight;
            const latestQuote = formattedHolding.latest_quote;
            if (changePercentVal !== null) {
                formattedHolding.change_percent_display = {
                    cssClass: parseFloat(changePercentVal.toString()) < 0 ? 'text-red' : 'text-green',
                    value: valFormatter(changePercentVal, 2),
                };
            }
            else {
                formattedHolding.change_percent_display = {
                    value: '--',
                };
            }
            formattedHolding.current_weight = currentWeight ? valFormatter(currentWeight, 2) : '--';
            formattedHolding.latest_quote = latestQuote ? figureMoneyFormatter(latestQuote, 2) : '--';
            // Format Overlap Attributions
            formattedHolding.attributions.forEach((attribution) => {
                const { weight } = attribution;
                attribution.weight = weight ? valFormatter(weight, 2) : '--'; // eslint-disable-line no-param-reassign
            });
            return formattedHolding;
        });
    }
    handleExport(format) {
        switch (format) {
            case CSV_FORMAT:
                this.exportHoldingDataUrl();
                break;
            case PDF_FORMAT:
                this.exportPDF();
                break;
            default:
                break;
        }
    }
    exportPDF() {
        const url = this.securitiesService.getExpandedHoldingsPDFReportUrl(this.securityId);
        if (url)
            downloadUrl(url);
    }
}
FlattenedHoldingsTableComponent.ɵfac = function FlattenedHoldingsTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FlattenedHoldingsTableComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.SecuritiesService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
FlattenedHoldingsTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FlattenedHoldingsTableComponent, selectors: [["ycn-flattened-holdings-table"]], inputs: { securityInput: "securityInput", displaySecurityInput: "displaySecurityInput" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 30, vars: 14, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action"], [1, "btn", "btn-secondary", 3, "click"], [1, "panel-action", 2, "position", "relative"], [3, "handler", "buttonClass", "config", "dropdownClass"], [1, "panel-content"], [1, "panel-pagination", "pt-1"], [1, "panel-pagination-content"], [1, "panel-pagination-count"], [1, "panel-pagination-content", 3, "pageChangeHandler", "paginationInfo", "disableButtons"], ["class", "table border-0", 4, "ngIf"], ["class", "table table-striped border-0", 4, "ngIf"], [3, "loaderMessage", 4, "ngIf"], [1, "panel-date"], [3, "closeModalHandler", "extraModalClasses", "open"], ["header", "Save as Watchlist", 3, "closeModalHandler"], [1, "modal-body"], [1, "modal-section", "section-info", 3, "textContent"], [1, "modal-footer", "user-select-none"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], [1, "table", "border-0"], [2, "cursor", "pointer", "user-select", "none"], ["data-test-id", "Column Headers"], [1, "colTxtMed", 3, "click", "ngClass"], [2, "padding-top", "0", "padding-bottom", "0"], [3, "click", "ngClass"], [1, "text-right", 3, "click", "ngClass"], [1, "colTxtShort", "text-right", 3, "click", "ngClass"], ["ycn-flattened-holding-item", "", 3, "holding", "fillRowBackground", 4, "ngFor", "ngForOf"], ["ycn-flattened-holding-item", "", 3, "holding", "fillRowBackground"], [1, "table", "table-striped", "border-0"], [4, "ngFor", "ngForOf"], [3, "href"], [1, "text-right"], [3, "loaderMessage"]], template: function FlattenedHoldingsTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, " All Holdings ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "a", 5);
        i0.ɵɵlistener("click", function FlattenedHoldingsTableComponent_Template_a_click_6_listener() { return ctx.saveAsWatchlist(); });
        i0.ɵɵtext(7, "Save as Watchlist");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 6)(9, "ycn-simple-dropdown", 7);
        i0.ɵɵlistener("handler", function FlattenedHoldingsTableComponent_Template_ycn_simple_dropdown_handler_9_listener($event) { return ctx.handleExport($event); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(10, "div", 8)(11, "div", 9)(12, "div", 10)(13, "div", 11);
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "ycn-pagination-controls", 12);
        i0.ɵɵlistener("pageChangeHandler", function FlattenedHoldingsTableComponent_Template_ycn_pagination_controls_pageChangeHandler_15_listener($event) { return ctx.pageChanged($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(16, FlattenedHoldingsTableComponent_table_16_Template, 19, 6, "table", 13)(17, FlattenedHoldingsTableComponent_table_17_Template, 3, 2, "table", 14)(18, FlattenedHoldingsTableComponent_ycn_loading_symbol_18_Template, 1, 1, "ycn-loading-symbol", 15);
        i0.ɵɵelementStart(19, "div", 16);
        i0.ɵɵtext(20, " Overlap includes all stock and bond holdings that are held in the portfolio or fund that have a weight >0.001%. ");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(21, "ycn-modal-base", 17);
        i0.ɵɵlistener("closeModalHandler", function FlattenedHoldingsTableComponent_Template_ycn_modal_base_closeModalHandler_21_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(22, "ycn-simple-modal-header", 18);
        i0.ɵɵlistener("closeModalHandler", function FlattenedHoldingsTableComponent_Template_ycn_simple_modal_header_closeModalHandler_22_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 19);
        i0.ɵɵelement(24, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 21)(26, "div", 22)(27, "div", 23);
        i0.ɵɵlistener("click", function FlattenedHoldingsTableComponent_Template_div_click_27_listener() { return ctx.closeModal(); });
        i0.ɵɵtext(28, " Close ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(29, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("buttonClass", "btn btn-secondary")("config", ctx.exportDropdownConfig)("dropdownClass", "dropdown-menu-with-icons");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate3(" Viewing ", ctx.paginationInfo.start_index, "-", ctx.paginationInfo.end_index, " of ", ctx.paginationInfo.num_items, " Securities ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("paginationInfo", ctx.paginationInfo)("disableButtons", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.hasRequiredFeature);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.showSaveAsWatchlistResult);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.saveAsWatchlistResult);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.FeatureNeededComponent, i5.LoadingSymbolComponent, i6.ModalBaseComponent, i7.SimpleModalHeaderComponent, i8.PaginationControlsComponent, i9.SimpleDropdownComponent, i10.FlattenedHoldingItemComponent], encapsulation: 2 });
